import script from "./login_wechat.vue?vue&type=script&lang=ts&setup=true"
export * from "./login_wechat.vue?vue&type=script&lang=ts&setup=true"

import "./login_wechat.vue?vue&type=style&index=0&id=67da6efe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67da6efe"]])

export default __exports__